module.exports = __webpack_public_path__ + "static/media/demoss hall.a3431010.jpeg";